import React from "react";
import PropTypes from "prop-types";
import Link, { ExternalLink } from "components/link";
import ListItem from "@material-ui/core/ListItem";
import ItemIcon from "./partial/item-icon";
import ItemText from "./partial/item-text";
import styles from "./styles/menu-item.css.js";
import withStyles from "components/with-styles";

const MenuItemContent = ({ text, disabled, selected, children }) => (
  <ListItem button selected={selected}>
    <>
      <ItemIcon disabled={disabled}>{children}</ItemIcon>
      <ItemText text={text} disabled={disabled} />
    </>
  </ListItem>
);

MenuItemContent.propTypes = {
  /**
   * Texto de la entrada de menú
   **/
  text: PropTypes.string,
  /**
   * Indica si la entrada de menú está deshabilitada
   **/
  disabled: PropTypes.bool,
  /**
   * Indica si la entrada de menú está seleccionada
   */
  selected: PropTypes.bool,
};

const MenuItem = ({ url, text, disabled, children, show = true, externalUrl, selected, classes, ...props }) => {
  const LinkComponent = externalUrl ? ExternalLink : Link;

  if (!show) {
    return null;
  }

  return disabled ? (
    <MenuItemContent disabled={disabled} selected={selected} text={text}>
      {children}
    </MenuItemContent>
  ) : (
    <LinkComponent className={classes.link} href={disabled ? undefined : url} {...props}>
      <MenuItemContent disabled={disabled} selected={selected} text={text}>
        {children}
      </MenuItemContent>
    </LinkComponent>
  );
};

MenuItem.propTypes = {
  /**
   * Indica si es una url externa a tiivii
   */
  externalUrl: PropTypes.bool,
  /**
   * Url de la entrada de menú
   **/
  url: PropTypes.string,
  /**
   * Texto de la entrada de menú
   **/
  text: PropTypes.string,
  /**
   * Indica si la entrada de menú está deshabilitada
   **/
  disabled: PropTypes.bool,
  /**
   * Indica si se muestra la entrada de menú
   **/
  show: PropTypes.bool,
  /**
   * Indica si la entrada de menú está seleccionada
   */
  selected: PropTypes.bool,
};

export default withStyles(styles)(MenuItem);
